'use client';

import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { useTranslation } from 'react-i18next';

function MultilineText({ text }: { text: string }) {
  const lines = text.split('\n');
  return (
    <>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
}

export default function Terms() {
  const { t } = useTranslation();

  return (
    <Layout>
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">{t('pageContent.terms.title')}</h1>
            <p className="text-sm text-gray-500 mb-8">{t('pageContent.terms.lastUpdated')}</p>

            <div className="prose prose-lg max-w-none">
              <h2>{t('pageContent.terms.sections.intro.title')}</h2>
              <p>{t('pageContent.terms.sections.intro.content')}</p>

              <h2>{t('pageContent.terms.sections.accounts.title')}</h2>
              <p>{t('pageContent.terms.sections.accounts.content')}</p>

              <h2>{t('pageContent.terms.sections.pitchDeck.title')}</h2>
              <p>{t('pageContent.terms.sections.pitchDeck.content')}</p>

              <h2>{t('pageContent.terms.sections.dataProtection.title')}</h2>
              <p><MultilineText text={t('pageContent.terms.sections.dataProtection.content')} /></p>

              <h2>{t('pageContent.terms.sections.payment.title')}</h2>
              <p>{t('pageContent.terms.sections.payment.content')}</p>

              <h2>{t('pageContent.terms.sections.withdrawal.title')}</h2>
              <p><MultilineText text={t('pageContent.terms.sections.withdrawal.content')} /></p>

              <h2>{t('pageContent.terms.sections.cancellation.title')}</h2>
              <p><MultilineText text={t('pageContent.terms.sections.cancellation.content')} /></p>

              <h2>{t('pageContent.terms.sections.liability.title')}</h2>
              <p>{t('pageContent.terms.sections.liability.content')}</p>

              <h2>{t('pageContent.terms.sections.governingLaw.title')}</h2>
              <p><MultilineText text={t('pageContent.terms.sections.governingLaw.content')} /></p>

              <h2>{t('pageContent.terms.sections.changes.title')}</h2>
              <p>{t('pageContent.terms.sections.changes.content')}</p>

              <h2>{t('pageContent.terms.sections.contact.title')}</h2>
              <p>{t('pageContent.terms.sections.contact.content')}</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
